import styled from "@emotion/styled";
import { ALWAYS_ON_TOP } from "constants/z-index";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
const FILTER_BLUE = "#0073ea";
const SUBTLE_LINE_COLOR = "#e1e1e1";
const FILTER_OPTION_SELECTED_COLOR = "#cce5ff";
export const StyledMobileFiltersComponent = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${ALWAYS_ON_TOP};

    .modal-content {
      background-color: ${Colors[WHITE_COLOR_NAME]};
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }

    .filters-section {
      margin-bottom: 100px;
    }

    .top-bar {
      align-items: center;
      position: sticky;
      top: 0;
      background-color: ${Colors[WHITE_COLOR_NAME]};
      z-index: ${ALWAYS_ON_TOP + 1};
    }

    .top-bar-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 16px 8px;
    }

    .close-button {
      padding: 0 62px 0 12px;
    }

    .filter-title {
      margin: 0;
      font-weight: 500;
    }

    .subtle-line {
      border: 0;
      border-top: 1px solid;
      border-color: ${SUBTLE_LINE_COLOR};
    }

    .filter-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      span {
        font-weight: 600;
      }
      &.has-selected {
        span {
          color: ${FILTER_BLUE};
        }
      }
    }

    .filter-content {
      margin-bottom: 12px;
      .option {
        display: flex;
        flex-direction: row;
        font-size: 1rem;
        padding: 12px;
        font-weight: 400;
        margin-bottom: 4px;

        .icon {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }

        &.selected {
          background-color: ${FILTER_OPTION_SELECTED_COLOR};
          color: ${FILTER_BLUE};
          padding: 12px;
          border-radius: 8px;
          box-sizing: border-box;
        }
      }
    }

    .down-arrow-wrapper {
      width: 14px;
      height: 14px;
      margin-right: 12px;
      transition: transform 0.3s ease-in-out;
    }

    .down-arrow-wrapper.open {
      transform: rotate(180deg);
      position: relative;
    }

    .down-arrow {
      width: 100%;
      height: 100%;
    }

  .clear-button {
    color: ${Colors.mud};
    cursor: not-allowed;
    padding: 0 12px;
  }

  .clear-button.active {
    color: ${FILTER_BLUE};
    cursor: pointer;
  }

  .bottom-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    background-color: ${Colors[WHITE_COLOR_NAME]};
    z-index: ${ALWAYS_ON_TOP + 1};
    width: 100%;
  }

  .apply-button {
    width: 80%;
    margin: 12px 0 24px;
    background-color: ${Colors.gainsboro};
    color: ${Colors.mud};
    border-radius: 8px;
    text-align: center;
    padding: 16px 0;
    &.active {
      background-color: ${FILTER_BLUE};
      color: ${Colors[WHITE_COLOR_NAME]};
      cursor: pointer;
    }
  }
`;
